<section class="embeds">
    <!-- desktop -->
    <div class="full">
        <!-- embed placeholder -->
        <div 
            *ngIf="embed.length == 0; else embedContainer" 
            class="embed-placeholder faded">
            <div>
                <mat-icon>code</mat-icon>
                <span>Embed</span>
            </div>
        </div>
        <!-- embed -->
        <ng-template #embedContainer>
            <div class="embed">
                <span>
                </span>                
            </div>
        </ng-template>
        <div>
            <richtext 
                [(value)]="embed"
                (valueChange)="slideEmbedChange()"
                placeholder="Embed URL"
                [removeButtons]="true"
                *ngIf="canEdit; else embedText">
            </richtext>
            <ng-template #embedText>
                <div [ngClass]="{faded: !embed}">{{embed ? embed : 'Embed URL'}}</div>
            </ng-template>
            <div class="word-count embed-split"></div>
        </div>
    </div>
</section>